import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TableUpdateActionButton from '../components/shared/buttons/TableUpdateActionbutton';
import TableDeleteActionButton from '../components/shared/buttons/TableDeleteActionbutton';
import ListTable, { TableLinkBtn }  from '../components/shared/ListTable';
import { dateFormat } from '../utils/date';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import {useNotifications} from 'reapop';
import axios from "../utils/axios";

const ARTICLE_LIST_URL = "article/";

const boolTranslate = (cellData) => {
    return cellData ? 'oui' : 'non'
}
const formatGroup = (groupData) => {
    return `${groupData.name}`
}

const COLUMNS = [
  { 
      id: 'title', 
      label: 'Titre', 
  },
  { 
      id: 'description', 
      label: 'Description', 
  },
  {
      id: 'author',
      label: 'Auteur',
  },
  {
      id: 'tags',
      label: 'Tags',
  },
  {
      id: 'display',
      label: 'Affichage',
  },
  {
      id: 'group',
      label: 'Groupe',
      format: formatGroup
  },
  {
      id: 'is_active',
      label: 'Actif',
      format: boolTranslate,

  },
  {
      id: 'created_at',
      label: 'Créer le',
      format: dateFormat,
  },
  {
      id: 'updated_at',
      label: 'Modifier le',
      format: dateFormat,
  },
  {
      id: 'action_btn',
      label: 'Actions',
      textAlign: true
  },
];
const AriticleListPage = ({articles}) => {
    const navigate = useNavigate();
    const {notify} = useNotifications();

    const [listArticles, setListArticles] = useState(articles);

    useEffect(() => { 
        setListArticles(articles);
    }, [articles]); 

    const showArticleUpdatePage = (idx) => {
        const path = ["update", idx].join('/');
        navigate(path);
    }

    const deleteButtonAction = async (idx) => {
        await axios.delete(`/article/${idx}`); 
        const index = listArticles.indexOf()
        var updatedList = listArticles.filter((a) => a.id != idx);
        setListArticles(updatedList);
        notify('L\'article a été supprimé', 'info', {dismissAfter: 5000}); 
    }    

    const deleteArticle = (idx) => { 
        const buttons = [
            {
                name: "Supprimer",
                primary: true,
                onClick: async() => {
                    await deleteButtonAction(idx);
                }
            },
            {
                name: "Annuler",
                primary: false,
                onClick: () => {
                    return;
                  }
            }
        ]
        notify('L\'article sera supprimé définitvement. Continuer ?', 'info', {buttons: buttons});
    };

    const extraColumnSetValue = (props) => {
        const action_btn = 
        <div>
            <TableUpdateActionButton clickHandler={showArticleUpdatePage} idx={props?.id} key={props?.id}/>
            <TableDeleteActionButton clickHandler={deleteArticle} idx={props?.id} key={props?.id}/>
        </div>;
        return {action_btn, ...props};
    }
    return (
        <Box>
            <TableLinkBtn to={'/article/create'}><PostAddOutlinedIcon/></TableLinkBtn>
            <ListTable 
                columns={COLUMNS}
                list_url={ARTICLE_LIST_URL}            
                callback={extraColumnSetValue}
                items={listArticles}
            />
        </Box>
    )
}

export default AriticleListPage;